import React, { FC, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';
import { ErrorLabel, SuccessLabel } from '@eika/label';
import { Loader } from '@eika/loader';

import { useETakst } from '../../hooks/useEiendom';
import { useTranslation } from '../../translations';
import ETakstFormData from './eTakstFormData';

const ETakstSoek: FC = () => {
    const { etakst, validationMessage } = useTranslation();
    const {
        control,
        register,
        setValue,
        formState: { errors },
    } = useFormContext<ETakstFormData>();
    const referansenummer = useWatch({ name: 'eTakst.referansenummer', control });
    const { data: eTakst, isFetched, isSuccess, isLoading } = useETakst(referansenummer);

    useEffect(() => {
        if (isFetched) {
            if (eTakst && eTakst.verdi > 0) {
                setValue('eTakst', eTakst);
            }
        }
    }, [isFetched, eTakst, setValue]);

    useEffect(() => {
        register('eTakst.aktivertDato', { required: `${validationMessage.requiredValue}` });
    }, [register, validationMessage.requiredValue]);

    return (
        <>
            <div>
                <Input
                    label={etakst.inputLabel}
                    sublabel={etakst.inputSubLabel}
                    className="max-width-400 margin-bottom-small"
                    type="text"
                    maxLength={5}
                    error={
                        errors.eTakst?.referansenummer?.type === 'manglerGyldigReferanseNummer'
                            ? `${validationMessage.requiredValue}`
                            : ''
                    }
                    {...register(`eTakst.referansenummer`, {
                        validate: {
                            manglerGyldigReferanseNummer: (value) => value.length > 0,
                        },
                    })}
                />
                {isLoading && <Loader mini />}
                {isSuccess && eTakst?.verdi === 0 && (
                    <ErrorLabel icon={IconTypes.UTROPSTEGN_24} text={etakst.invalidETakst} />
                )}
                {isSuccess && eTakst?.verdi > 0 && (
                    <SuccessLabel text={etakst.validETakst} icon={IconTypes.USP_CHECKMARK_24} />
                )}
            </div>
        </>
    );
};

export default ETakstSoek;
